import axios from 'axios';

const BASE_URL = process.env.VUE_APP_API_ENDPOINT || '';

/**
 * Check if an email already exists via the backend API.
 * Returns { proceed: true } if the user can continue,
 * or { proceed: false, reason: '...', ... } if they should be blocked.
 * On any API error, returns { proceed: true } so the user is never blocked by a failure.
 */
export async function checkEmail(email) {
  try {
    const response = await axios.post(`${BASE_URL}/api/check-email`, { email });
    const { email_found, paid_user, user_role } = response.data;

    if (!email_found) {
      return { proceed: true };
    }

    // Email found — check role first
    if (user_role && user_role !== 'USER') {
      return { proceed: false, reason: 'wrong_role', role: user_role };
    }

    // Email found, role is USER — check if paid
    if (paid_user) {
      return { proceed: false, reason: 'paid_user' };
    }

    // Found but not paid, role is USER — allow
    return { proceed: true };
  } catch (error) {
    // Never block the user on API failure
    console.error('Email check error:', error);
    return { proceed: true };
  }
}

/**
 * Validate email format before calling the API.
 */
export function isValidEmailFormat(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
